export const PROD_API_BASE_URL = "https://api.health.somnofy.com/";

export const WIPMessageUrl = "https://static.somnofy.com/messages/honu";

export const API_URLS = [
  "http://localhost:5001/",
  "https://stage.api.health.somnofy.dev/",
  "https://api.health.somnofy.com/",
];

export const AUTH_URLS = [
  "http://localhost:9011/",
  "https://stage.auth.somnofy.dev/",
  "https://auth.somnofy.com/",
];

export const SHOW_API_SELECTOR =
  globalThis.location.hostname === "localhost" ||
  globalThis.location.hostname === "test.insights.vitalthings.com" ||
  globalThis.location.hostname === "staging.insights.vitalthings.com";
